import { args } from 'nest/common/args';
import { defineCapability } from 'nest/capabilities';

export const TOGGLE_NOTIFICATION_SIDEBAR_CAP = defineCapability({
  name: 'TOGGLE_NOTIFICATION_SIDEBAR_CAP' as const,
  args: {
    isOpen: args.bool(),
  },
});
